import { useSurveysContext } from 'features/surveys/SurveysContext';
import useUserData from 'hooks/useUserData';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { getOnboardingData, setOnboardingData } from './OnboardingStorage';
export const OnboardingContext = React.createContext<{
  needShowOnboarding: boolean;
  loaded: boolean;
  onboardingName: string;
  saveLog: () => void;
}>({
  needShowOnboarding: false,
  onboardingName: '',
  loaded: false,
  saveLog: () => {
    //nothing
  },
});
const activeSchoolListValid = (userData: ReturnType<typeof useUserData>, mediaQuery: MediaQueryList) => {
  if (mediaQuery.matches && (userData?.isMunicipality || userData?.isCityDistrict)) {
    return 'activeSchoolList';
  }
  return '';
};

export const OnboardingContextProvider = (props: React.PropsWithChildren<{}>) => {
  const [loaded, setLoaded] = useState(false);
  const [needShowOnboarding, setNeedShowOnboarding] = useState(false);
  const [onboardingName, setOnboardingName] = useState('');
  const userData = useUserData();
  const { avalibleSurvey, loaded: surveyLoaded, visitedPage } = useSurveysContext();

  useEffect(() => {
    if (!userData?.id || !surveyLoaded) return;
    const mediaQuery = window.matchMedia('(min-width: 1280px) and (min-height: 600px)');
    const onboarings = [
      activeSchoolListValid(userData, mediaQuery),
      avalibleSurvey && !visitedPage ? avalibleSurvey : '',
    ].filter((el) => el);

    const loggedOnboarding = getOnboardingData();
    const loggedOnboardingList = Object.keys(loggedOnboarding);
    const [currentOnboarding] = onboarings.filter((el) => !loggedOnboardingList.includes(el));

    if (currentOnboarding) {
      setOnboardingName(currentOnboarding);
      setNeedShowOnboarding(true);
    }
    setLoaded(true);
  }, [userData, surveyLoaded]);

  const saveLog = () => {
    setOnboardingData(onboardingName);
    setOnboardingName('');
  };

  return (
    <OnboardingContext.Provider value={{ needShowOnboarding, onboardingName, saveLog, loaded }}>
      {props.children}
    </OnboardingContext.Provider>
  );
};
